import App from 'app/app.js';
import 'app/directive/LtPictureDayFormCtrl.js';

function LtPictureDayAnotherStudentFormDirective() {
  return {
    restrict: 'E',
    scope: {
      disableidcntrl: '=',
      accessCode: '=',
      cancelLabel: '=',
      firstName: '=',
      subjectLastName: '=',
      lockPortraitId: '=',
      onCancel: '&',
      onContinue: '&',
      pictureDayCopy: '=',
      portraitId: '=',
      pageScope: '='
    },
    template:
      '<form ng-submit="pictureDayAnotherStudentForm.onContinue()" class="fpd" novalidate="novalidate" name="pictureIdForm" data-test-id="d4a5c9b6-87a9-4105-af65-f7175de69b3b">' +
      '  <div class="row" data-test-id="61517f0a-03b8-4cdc-9c48-2eb6dc8151ea">' +
      '    <div class="col-xs-12" data-test-id="8016bb83-4da6-45dd-b686-71673bf738e5">' +
      '      <p class="font-14 picture-day-header" lt-translate="{{pictureDayCopy}}">Enter the Picture Day ID from your order form or your Portrait ID from your proof sheet or envelope</p>' +
      '    </div>' +
      '  </div>' +
      '  <div class="fpd-form-links actions" ng-hide="pageScope == \'SPORTZ\'" data-test-id="a18b7239-478e-46be-a0fa-391506b64d09">' +
      '    <ul>' +
      '      <li><a href="" class="fpd-link camera-icon" ng-click="findMyPictureDay($event)" lt-translate="FIND_MY_PICTURE_DAY_HOME_PAGE_$COUNTRY" data-test-find-picture-day-id></a></li>' +
      '    </ul>' +
      '  </div>' +
      '  <div class="row fieldset-portrait-id" ng-class="{valid: pictureDayAnotherStudentForm.isPortraitIdValid()}">' +
      '    <label for="portrait-id" aria-label="Search by Picture Day ID or Portrait ID">' +
      '      <span class="sr-only" aria-hidden="true">Search by Picture Day ID or Portrait ID</span>' +
      '    </label>' +
      '    <input type="text" class="portrait-id" ng-disabled="disableidcntrl" lt-focus="!pictureDayAnotherStudentForm.isPortraitIdValid()" lt-key-filter="name" maxlength="10" ng-model="pictureDayAnotherStudentForm.portraitId" placeholder=\'{{pictureDayAnotherStudentForm.getPlaceholderByCountry("PICTURE_DAY_FORM_HELPER")}}\'' +
      ' data-test-portrait-id />' +
      '  </div>' +
      '  <div  class="row fieldset-portrait-id" ng-class="{valid: pictureDayAnotherStudentForm.isAccessCodeValid()}" ng-show="pictureDayAnotherStudentForm.isPortraitIdEntered()">' +
      '    <label for="access-code" aria-label="Enter Access Code">' +
      '      <span class="sr-only">Enter Access Code</span>' +
      '      <span class="mlt-spacer"></span>' +
      '    </label>' +
      '    <input type="text" name="accessCode" lt-key-filter="name" maxlength="4" ng-model="pictureDayAnotherStudentForm.accessCode" placeholder=\'{{pictureDayAnotherStudentForm.getPlaceholderByCountry("PICTURE_DAY_FORM_ACCESS_CODE")}}\' data-test-access-code required/>' +
      '  </div>' +
      '  <div class="row fieldset-portrait-id" ng-class="{valid: pictureDayAnotherStudentForm.isSubjectLastNameValid()}"' +
      ' ng-show="pictureDayAnotherStudentForm.isPortraitIdEntered()">' +
      '    <label for="subjectLastName"' +
      ' aria-label="{{pictureDayAnotherStudentForm.getPlaceholderByCountry("PICTURE_DAY_FORM_LAST_NAME")}}">' +
      '      <span' +
      ' class="sr-only">{{pictureDayAnotherStudentForm.getPlaceholderByCountry("PICTURE_DAY_FORM_LAST_NAME")}}</span>' +
      '      <span class="mlt-spacer"></span>' +
      '    </label>' +
      '    <input type="text" name="subjectLastName" maxlength="50" lt-key-filter="name" ng-model="pictureDayForm.subjectLastName" placeholder=\'{{pictureDayAnotherStudentForm.getPlaceholderByCountry("PICTURE_DAY_FORM_LAST_NAME")}}\' data-test-subject-last-name required/>' +
      '  </div>' +
      '  <div  class="row fieldset-portrait-id" ng-class="{valid: pictureDayAnotherStudentForm.isFirstNameValid()}" ng-show="pictureDayAnotherStudentForm.isPortraitIdValid()">' +
      '    <label for="first-name" aria-label="Enter Child\'s First Name">' +
      '      <span class="sr-only">Enter Child\'s First Name</span>' +
      '      <span class="mlt-spacer"></span>' +
      '    </label>' +
      '    <input type="text" name="first-name" lt-focus="pictureDayAnotherStudentForm.isPortraitIdValid()" lt-key-filter="name" maxlength="16" ng-model="pictureDayAnotherStudentForm.firstName" placeholder=\'{{pictureDayAnotherStudentForm.getPlaceholder("PICTURE_DAY_FORM_CHILD_FIRST_NAME")}}\' data-test-first-name />' +
      '  </div>' +
      '  <div class="actions" data-test-id="3072a508-2f0e-4d50-8a50-37fdbd65f11c">' +
      '    <input type="reset" role="button" value="Reset" data-test-reset-link />' +
      '  </div>' +
      '  <div class="row"  data-test-id="a5d985c0-470b-49f0-a8ba-10a8aa711813">' +
      '    <div class="text-center"  data-test-id="13804f58-d7cf-4ab1-8144-257d441a119b">' +
      '      <input class="lt-primary-button shopNowButton" ng-class="{invalidButton: !pictureDayAnotherStudentForm.isPortraitIdValid() || !pictureDayAnotherStudentForm.isFirstNameValid()}" role="button" type="submit" ' +
      'value="START SHOPPING!" ng-show="pictureDayAnotherStudentForm.isPortraitIdValid()" ' +
      'ng-disabled="!pictureDayAnotherStudentForm.isPortraitIdValid() || !pictureDayAnotherStudentForm.isFirstNameValid()" data-test-shop-now-btn />' +
      '    </div>' +
      '  </div>' +
      '</form>',
    controller: 'LtPictureDayFormCtrl',
    controllerAs: 'pictureDayAnotherStudentForm',
    link: function (scope, element, attrs, pictureDayAnotherStudentForm) {
      pictureDayAnotherStudentForm.setPortraitId();
    }
  };
}
App.directive('ltPictureDayAnotherStudentForm', [LtPictureDayAnotherStudentFormDirective]);
